import {
  Badge,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';
import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
} from 'react';
import { AuthContext, ConferenceContext } from '@/store';
import UserAvatar from '@/components/ui/userAvatar';

const useStyles = (theme) => ({
  followMenu: {
    width: '300px !important',
    maxHeight: '400px !important',
    border: '1px solid #FFFFFF99 !important',
    color: `${theme.palette.text.primary} !important`,
    backgroundColor: `${theme.palette.background.default} !important`,
    borderWidth: '1px !important',
    borderStyle: 'solid !important',
    borderColor: `${theme.palette.background.shadedown_20} !important`,
    boxShadow: '0 0 15px rgb(0, 0, 0, 0.15) !important',
    padding: '5px !important',
    borderRadius: '3px !important',
  },
});

const FollowMenu = (_props, ref) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { authState, dispatch } = useContext(AuthContext);
  const { openUserPopup } = useContext(ConferenceContext);
  const [menuState, setMenu] = useState({
    open: false,
    menuTarget: null,
    list: [],
    new: 0,
    loading: false,
  });

  const handleClose = () => {
    setMenu({
      open: false,
      menuTarget: null,
      list: [],
      new: 0,
      loading: false,
    });
  };

  const loadFollowers = () => {
    axios
      .get(`/api/visitor/followers`)
      .then((response) => {
        setMenu((prevSate) => ({
          ...prevSate,
          list: response.data.followed,
          loading: false,
        }));
        dispatch({ type: 'UPDATE_FOLLOW', followData: { follows_new: 0 } });
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  useImperativeHandle(ref, () => ({
    open: (menuTarget) => {
      setMenu({
        ...menuState,
        open: true,
        menuTarget: menuTarget,
        list: [],
        new: authState.user.follows_new,
        loading: true,
      });
      // Load list
      loadFollowers();
    },
    close: handleClose,
  }));

  return (
    <Menu
      id="menu-followbar"
      anchorEl={menuState.menuTarget}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      open={menuState.open}
      onClose={handleClose}
      slotProps={{ paper: { sx: classes.followMenu } }}
    >
      {menuState.loading ? (
        <MenuItem>Loading...</MenuItem>
      ) : menuState.list.length === 0 ? (
        <MenuItem>No E-Cards exchanged</MenuItem>
      ) : (
        [
          <MenuItem key={0}>E-Cards:</MenuItem>,
          ...menuState.list.map((user, index) => (
            <MenuItem key={user.id} onClick={() => openUserPopup(user)}>
              <ListItemIcon>
                {index < menuState.new ? (
                  <Badge variant="dot" color="primary">
                    <UserAvatar size="medium" user={user} />
                  </Badge>
                ) : (
                  <UserAvatar size="medium" user={user} />
                )}
              </ListItemIcon>
              <ListItemText primary={user.full_name} />
            </MenuItem>
          )),
        ]
      )}
    </Menu>
  );
};

export default forwardRef(FollowMenu);
